import React from "react";
import { ExclamationIcon } from "@heroicons/react/outline";
import { useHistory } from "react-router";
import PropTypes from "prop-types";

import { Modal, ModalBody, ModalFooter, ModalTitle } from "../Modal";
import Button from "../Button";

export default function Logout({ closeConfirmModal }) {
  const history = useHistory();

  function onConfirmSignOut() {
    closeConfirmModal();
    history.push("/logout");
  }

  return (
    <Modal isOpened={true} onClose={closeConfirmModal}>
      <ModalTitle
        titleIcon={
          <ExclamationIcon
            className="h-6 w-6 text-red-600"
            aria-hidden="true"
          />
        }
      >
        Confirmation
      </ModalTitle>
      <ModalBody>
        You have some unsynced changed. Do you want to logout anyway?
      </ModalBody>
      <ModalFooter>
        <Button intent="danger" onClick={onConfirmSignOut} type="button">
          Remove unsynced changes and logout
        </Button>
        <Button
          intent="link"
          className="ml-1 rounded-md border border-gray-300"
          onClick={closeConfirmModal}
          type="button"
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

Logout.propTypes = {
  closeConfirmModal: PropTypes.func.isRequired,
};
